import { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';

const HEALTH_PATH = '/health';
const TEN_MINUTES = 10 * 60 * 1000;

export const useInteractionHealthCheck = () => {
  const lastInteractionTimeRef = useRef(Date.now());

  const checkHealthOnInteraction = useCallback(() => {
    const now = Date.now();
    if (now - lastInteractionTimeRef.current > TEN_MINUTES) {
      axios
        .get(HEALTH_PATH, { withCredentials: true })
        .catch(() => {
          // ignore failures; this is a lightweight ping
        })
        .finally(() => {
          lastInteractionTimeRef.current = now;
        });
    }
  }, []);

  return checkHealthOnInteraction;
};

export const useWindowHealthCheck = (enabled = true) => {
  const focusHandlerRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const performHealthCheck = () => {
      axios.get(HEALTH_PATH, { withCredentials: true }).catch(() => {
        // ignore errors
      });
    };

    // initial ping
    performHealthCheck();

    const handleFocus = () => performHealthCheck();
    focusHandlerRef.current = handleFocus;
    window.addEventListener('focus', handleFocus);

    return () => {
      if (focusHandlerRef.current) {
        window.removeEventListener('focus', focusHandlerRef.current);
      }
    };
  }, [enabled]);
};
